module.exports = __webpack_public_path__ + "static/settings-2149d369ca6b64b65cd921a38d2f03e0.png";